import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Container, Form, Header, Icon, Modal, Segment, Table } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import api from "./api";
import _ from "lodash";
import moment from "moment";
import { convertPayload } from "../ManageRequests";
import Comparison from "../../components/Comparison";
import { hasPermission } from "../../../../reducer";
import { push } from "react-router-redux";


const inlineStyle = {
    modal: {
        marginTop: "0px !important",
        marginLeft: "auto",
        marginRight: "auto"
    }
};


class MyRequests extends Component {

    constructor(props) {
        super(props);
        this.state = {
            requests: [],
            activeRequest: null,
            activePayload: false,
            activeRequestId: 0,
            activeComparison: {},
            payloadModalOpen: false,
            comment: "",
            search: "",
        };
    }

    componentDidMount() {
        if (!this.props.hasPermission) {
            return this.props.redirectNoPermission();
        }
        this.reloadRequests();
    }

    reloadRequests() {
        api.loadRequests()
            .then((requests) => {
                this.setState({ requests });
            });
    }


    handleSearchChange(e, { value }) {
        this.setState({
            search: value,
        });

    }

    render() {
        const search = this.state.search;
        const { translate } = this.props;

        return <div>

            <Header as='h2' icon textAlign='center'>
                <Icon name='columns' circular/>
            </Header>
            <Header as='h2' color='teal' textAlign='center'>
                {this.props.translate("tools.manageRequests.header")}
            </Header>
            <Container fluid>


                <Segment attached padded>

                    <Form>
                        <Form.Input
                            onChange={_.bind(_.debounce(this.handleSearchChange, 500, { leading: true }), this)}
                            value={this.state.search}
                            label={translate("general.search")}
                        />
                    </Form>

                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.type")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.status")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.creator")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.comment")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.created")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.revised")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.revisedBy")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.revisionComment")}</Table.HeaderCell>
                                <Table.HeaderCell>{translate("tools.manageRequests.fields.action")}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {this.state.requests.sort((a, b) => {
                                if (a.type === "open") {
                                    return 1;
                                }
                                return -1;
                            })
                                .filter((request) => {

                                    if (search === "") {
                                        return true;
                                    }

                                    for (let key in request) {

                                        if (request[key] && request[key].toString()
                                            .toLowerCase()
                                            .includes(search.toLowerCase())) {
                                            return true;
                                        } else if (request[key] && key === "payload" && JSON.stringify(request[key])
                                            .toLowerCase()
                                            .includes(search.toLowerCase())) {
                                            return true;
                                        } else if (request[key] && key === "comparison" && JSON.stringify(request[key])
                                            .toLowerCase()
                                            .includes(search.toLowerCase())) {
                                            return true;
                                        }
                                    }

                                    return false;

                                })
                                .map((request, key) =>
                                    <Table.Row key={key}>
                                        <Table.Cell>{translate("tools.manageRequests.type." + request.type)}</Table.Cell>
                                        <Table.Cell>{translate("tools.manageRequests.status." + request.status)}</Table.Cell>
                                        <Table.Cell>{request.creator}</Table.Cell>
                                        <Table.Cell>{request.comment}</Table.Cell>
                                        <Table.Cell>{request.created_at}</Table.Cell>
                                        <Table.Cell>{request.revised_at ? moment.unix(request.revised_at)
                                            .format("YYYY-DD-MM HH:mm:ss") : "-"}</Table.Cell>
                                        <Table.Cell>{request.revisor}</Table.Cell>
                                        <Table.Cell>{request.revisionComment}</Table.Cell>
                                        <Table.Cell>
                                            <Button primary onClick={() => {
                                                this.setState({
                                                    payloadModalOpen: true,
                                                    activePayload: convertPayload(request.payload),
                                                    activeComparison: typeof request.comparison === "object" ? request.comparison : {}
                                                });
                                            }}>{translate("tools.manageRequests.fields.showDetails")}</Button>
                                        </Table.Cell>
                                    </Table.Row>)}
                        </Table.Body>

                    </Table>

                    <Modal
                        size='fullscreen'
                        style={inlineStyle.modal}
                        open={this.state.payloadModalOpen}
                        onClose={() => {
                            this.setState({ payloadModalOpen: false });
                        }}
                    >
                        <Modal.Header>{translate("tools.manageRequests.fields.showDetails")}</Modal.Header>
                        <Modal.Content>
                            <Comparison productIdsReversed={true}
                                        product={this.state.activePayload}
                                        comparison={this.state.activeComparison}/>
                        </Modal.Content>
                    </Modal>


                </Segment>
            </Container>
        </div>;
    }


}


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    hasPermission: hasPermission(state, "masterDataRequests")

});


const mapDispatchToProps = (dispatch) => {
    return ({
        redirectNoPermission: () => (dispatch(push("/")))
    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyRequests);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MyRequests/index.js